import { MerchantAddressModel } from "@/model/address/addressModel";

export function ConvertToMerchantDetail(detail: any) {
  return detail;
}

export function ConvertToMerchantAddress(addressList: any) {
  const merchantAddressList: Array<MerchantAddressModel> = [];
  if (addressList && addressList.length > 0) {
    addressList.forEach((address: any) => {
      const merchantAddress: MerchantAddressModel = {
        addressInfoType: address.addressInfoType,
        address: address.no,
        addressName: address.addressName,
        building: address.building,
        country: address.country,
        district: address.district2,
        floorNo: address.floorNo,
        homeGroup: address.homeGroup,
        homeNo: address.homeNo,
        id: address.id,
        language: address.language,
        name: address.name,
        postCode: address.postCode,
        province: address.province,
        road: address.road,
        roomNo: address.roomNo,
        soi: address.soi,
        subDistrict: address.district1,
      };

      merchantAddressList.push(merchantAddress);
    });
  }
  return merchantAddressList;
}
